<template>
    <div class="waiting">
        <img class="empty-image" src="/img/waiting.png" alt="暂未搜索到结果">
    </div>

</template>

<script>
    export default {
        name: "waiting"
    }
</script>

<style scoped lang="scss">
    .waiting {
        margin-top: 100px;
        width: 100%;
        text-align: center;
        .empty-tip {
            text-align: center;
            font-size:12px;
            font-weight:400;
            color:rgba(102,102,102,1);
            margin-top: 20px;
        }
        .empty-image{
            width: 300px;
            height: auto;
        }

    }
</style>